import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';
import {Tariff, TariffSearchParams} from '@accounting/_common/models/accrual-tariff.models';

export const CheckState = createAction(
    '[Tariffs] Check State',
    props<{ payload: { modalView: boolean, close: boolean, items: Tariff[] } }>()
);

export const CheckStateSuccess = createAction(
    '[Tariffs] Check State Success',
    props<{ payload: { modalView: boolean, close: boolean, items: Tariff[] } }>()
);

export const LoadList = createAction(
    '[Tariffs] Load List',
    props<{ payload: { loading: DahLoadingType, clearState: boolean } }>()
);

export const LoadListSuccess = createAction(
    '[Tariffs] Load List Success',
    props<{ payload: { items: Tariff[], pagination: DahPaginationModel, clearState: boolean } }>()
);

export const LoadListFailure = createAction(
    '[Tariffs] Load List Failure',
    props<{ payload: HttpErrorResponse }>()
);

export const SetPagination = createAction(
    '[Tariffs] Set Pagination',
    props<{ payload: boolean }>()
);

export const SetFilter = createAction(
    '[Tariffs] Set Filter',
    props<{ payload: TariffSearchParams }>()
);

export const SetLoading = createAction(
    '[Tariffs] Set Loading',
    props<{ payload: DahLoadingType }>()
);

export const SetItemsLoading = createAction(
    '[Tariffs] Set Items Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

export const UpdateItemSuccess = createAction(
    '[Tariffs] Update Item Success',
    props<{ payload: Tariff }>()
);

export const DeleteItem = createAction(
    '[Tariffs] Delete Item',
    props<{ payload: Tariff }>()
);

export const DeleteItemSuccess = createAction(
    '[Tariffs] Delete Item Success',
    props<{ payload: Tariff }>()
);

export const DeleteItemFailure = createAction(
    '[Tariffs] Delete Item Failure',
    props<{ payload: Tariff }>()
);

export const SetInitialState = createAction(
    '[Tariffs] Set Initial State'
);

export const UpdateTariffItem = createAction(
    '[Tariffs] Update Tariffs Item',
    props<{ payload: Tariff }>()
);
